import {Injectable} from '@angular/core';
import {getLockIconConfig} from '@application/helper/get-lock-icon-config';
import {HttpStockLocationService} from '@infrastructure/http/stock-location/http-stock-location.service';
import {
  ColDefBuilderFactoryService,
  ContentSwitcherNavigationInput,
  CrudColdef,
  GridOptionsBuilder,
  LinkIconRendererComponent,
  NoDataOverlayComponentParams,
  OverlayComponentParams,
  TranslateService
} from '@vdw/angular-component-library';
import {ICellRendererParams} from 'ag-grid-community';
import {Subject} from 'rxjs';
import {AddStockLocationComponent} from './add-stock-location/add-stock-location.component';

@Injectable({providedIn: 'root'})
export class StockLocationOverviewService {
  public constructor(
    private readonly colDefBuilder: ColDefBuilderFactoryService,
    private readonly stockLocations: HttpStockLocationService,
    private readonly translate: TranslateService
  ) {}

  public getColumnDefs(withLinkIcon: boolean = true, rowActionsComplete?: Subject<void>): CrudColdef {
    let nameColDef = this.colDefBuilder
      .getBuilder()
      .withField('name')
      .withHeaderName(this.translate.instant('UTILITIES.TOOL.STOCK_LOCATION', {count: 1}));

    if (withLinkIcon) {
      nameColDef = nameColDef.withCellRenderer(LinkIconRendererComponent, (params: ICellRendererParams) => {
        return {
          params,
          rowActionsComplete,
          contentSwitcherEntry: {componentInfo: {component: AddStockLocationComponent}} as ContentSwitcherNavigationInput,
          lockIconConfig: getLockIconConfig(params.data.name, this.stockLocations.getConflicts(params.data.id), rowActionsComplete)
        };
      });
    }

    return {colDefs: [this.colDefBuilder.getBuilder().withField('id').withHide().build(), nameColDef.build()], rowActionsComplete} as CrudColdef;
  }

  public getDefaultGridOptionsBuilder(builder: GridOptionsBuilder): GridOptionsBuilder {
    return builder
      .withLoadingOverlay({scale: 0.7} as OverlayComponentParams)
      .withNoRowsOverlay({scale: 0.7, titleParam: this.translate.instant('UTILITIES.TOOL.STOCK_LOCATION', {count: 1}), hideDescription: true} as NoDataOverlayComponentParams);
  }
}
